import { getNameModelUtil } from '../../../../model'

function isBreathingExerciseUtil (exercise) {
  return getNameModelUtil(exercise)
    .includes('Breath')
}

export { isBreathingExerciseUtil }
